const API_URL = import.meta.env.VITE_API_URL

//export const Login_URL = `${API_URL}auth/`
export const Login_URL = `${API_URL}security/`
export const REPORT_URL = `${API_URL}reports/`
export const Study_URL = `${API_URL}study/`
export const Security_URL = `${API_URL}security/`
export const Product_URL = `${API_URL}product/`
export const Pharma_URL = `${API_URL}pharma/`
export const Dictionary_URL = `${API_URL}dictionary/`
export const Admin_URL = `${API_URL}admin/`
export const Des_URL = `${API_URL}des/`
export const systemMaintenance_URL = `${API_URL}admin/`
